export default ".input input {\n  display: none;\n}\n\n.input span {\n  padding-left: 15px;\n}\n\n#filename {\n  display: block;\n}";